import { Store, Truck, Printer, Megaphone, ShoppingCart, Check } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { MODELS } from "../../data/site";

const ICONS = [Store, Truck, Printer, Megaphone, ShoppingCart];

export const BusinessModels = () => (
  <section id="models" data-testid="models-section" className="py-24 sm:py-28 bg-navy relative overflow-hidden">
    <div className="absolute inset-0 bg-grid-navy" />
    <div className="absolute -top-32 right-0 w-[440px] h-[440px] rounded-full bg-electric/15 blur-[130px]" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        dark
        overline="Business Models"
        title="Five Online Business Models You'll Explore"
        sub="During the program you'll explore all five — then choose one for your final practical project."
      />
      <div className="mt-14 grid md:grid-cols-2 gap-6">
        {MODELS.map((m, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={m.n} delay={(i % 2) * 0.1} className={i === MODELS.length - 1 ? "md:col-span-2 md:max-w-[calc(50%-12px)] md:mx-auto md:w-full" : ""}>
              <div
                data-testid={`model-card-${m.n}`}
                className="group h-full bg-navy-800/70 backdrop-blur border border-white/10 rounded-2xl p-7 sm:p-8 hover:border-cyanx/40 hover:-translate-y-1.5 transition-all duration-300"
              >
                <div className="flex items-start justify-between gap-4">
                  <span className="w-12 h-12 rounded-xl bg-electric/20 border border-electric/30 flex items-center justify-center group-hover:bg-electric transition-colors">
                    <Icon size={20} className="text-cyanx group-hover:text-white transition-colors" />
                  </span>
                  <span className="font-display font-extrabold text-4xl text-white/10 group-hover:text-cyanx/25 transition-colors">{m.n}</span>
                </div>
                <h3 className="mt-5 font-display font-bold text-white text-xl">{m.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{m.desc}</p>
                <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.2em] text-cyanx">You'll Learn</p>
                <ul className="mt-3 grid sm:grid-cols-2 gap-x-6 gap-y-2">
                  {m.items.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-[13px] text-slate-300 leading-relaxed">
                      <Check size={12} strokeWidth={3} className="text-cyanx mt-1 shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
